import { invariant } from "../../utilities/globals/index.js";
import * as React from 'react';
import { getApolloContext } from "./ApolloContext.js";
export var ApolloConsumer = function (props) {
    var ApolloContext = getApolloContext();
    return (React.createElement(ApolloContext.Consumer, null, function (context) {
        __DEV__ ? invariant(context && context.client, 'Could not find "client" in the context of ApolloConsumer. ' +
            'Wrap the root component in an <ApolloProvider>.') : invariant(context && context.client, 28);
        return props.children(context.client);
    }));
};
//# sourceMappingURL=ApolloConsumer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/react/context/ApolloConsumer.js
// module id = 1513
// module chunks = 4